<template>
  <UiDialog
    class="TemplateButton"
    :open.sync="isOpen"
    :close-scrim="false"
    @open="fetchTemplates"
  >
    <template #trigger>
      <UiIcon
        :title="$t('TemplateButton.title')"
        value="mdi:newspaper-variant-outline"
        class="ToolbarButton"
      ></UiIcon>
    </template>

    <template #contents>
      <h1>{{ $t('TemplateButton.title') }}</h1> <br>

      <UiPicker
        :options="templates"
        optionText="name"
        optionKey="content"
        v-model="templateSelected"
        :hideSearch="true"
      />

      <div v-html="templateSelected"></div>

    </template>

    <template #footer>
      <button
        type="button"
        class="ui-native --main"
        @click="onAccept"
      >{{ $t('TemplateButton.Accept') }}</button>
      <button
        type="button"
        class="ui-native --cancel"
        @click="onCancel"
      >{{ $t('TemplateButton.Cancel') }}</button>
    </template>
  </UiDialog>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import useApi from '@/modules/api/mixins/useApi.js';
import { UiDialog, UiIcon, UiInput, UiPicker } from '@/modules/ui/components';
import apiTemplates from '../api/templates.js';
import app from '@/store/app.js';

export default {
  components: {
    UiDialog,
    UiIcon,
    UiInput,
    UiPicker,
  },

  mixins: [useI18n, useApi],
  $api: apiTemplates,

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
      templateSelected: '',
      templates: [],
      isFetched: false,
    };
  },

  methods: {
    async fetchTemplates() {
      if (this.isFetched) {
        return;
      }

      this.templates = await this.$api.getTemplates(app.user.id);

      this.templates.forEach((template) => {
        this.$set(template, 'name', template.title)
      });

      this.isFetched = true;
    },

    onAccept() {
      this.editor.commands.insertContent(this.templateSelected, {
        parseOptions: { preserveWhitespace: false },
      });

      this.templateSelected = '';

      this.isOpen = false;
    },

    onCancel() {
      this.templateSelected = '';
      this.isOpen = false;
    },
  },

  i18n: {
    en: {
      'TemplateButton.title': 'Insert template',
      'TemplateButton.Accept': 'Accept',
      'TemplateButton.Cancel': 'Cancel',
    },

    en: {
      'TemplateButton.Cancel': 'Cancel',
      'TemplateButton.Accept': 'Accept',
      'TemplateButton.title': 'Insert template',
    },

    es: {
      'TemplateButton.Cancel': 'Cancelar',
      'TemplateButton.Accept': 'Aceptar',
      'TemplateButton.title': 'Insertar plantilla',
    },

    de: {
      'TemplateButton.Cancel': 'Abbrechen',
      'TemplateButton.Accept': 'Akzeptieren',
      'TemplateButton.title': 'Vorlage einfügen',
    },
  },
};
</script>

<style lang="scss">
.TemplateButton {
  .ui-dialog-container {
    top: 30% !important;
    bottom: 10% !important;
    max-height: 50% !important;
    max-width: 600px !important;
  }
}
</style>